import React from "react";

import { useTranslation } from "react-i18next";

import { FormChoiceInput } from "@/uiKit/molecules/form/FormChoiceInput.tsx";

type DiabetesType = "type1" | "type2" | "gestational";

type InsulinScheme = "noInsulin" | "insulinPen" | "insulinPump";

export type InsulinSchemeFormFieldProps = {
  name?: string;
  diabetesType: DiabetesType | undefined;
  allowedInsulinSchemes: InsulinScheme[];
  translationMapping: (type: InsulinScheme) => string;
  className?: string;
};

export const InsulinSchemeFormField: React.FC<InsulinSchemeFormFieldProps> = ({
  name = "insulinScheme",
  diabetesType,
  allowedInsulinSchemes,
  translationMapping,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <FormChoiceInput
      id="insulin-scheme-form-field"
      name={name}
      label={t("diabetesForms.insulinScheme")}
      className={className}
      choices={allowedInsulinSchemes
        .filter(
          type =>
            (diabetesType === "gestational" && type !== "insulinPump") || // When gestational, exclude insulinPump
            (diabetesType !== "gestational" && type !== "noInsulin"), // When T1 or T2, exclude noInsulin
        )
        .map(type => ({
          label: t(translationMapping(type)),
          value: type,
        }))}
      reserveErrorSpace
    />
  );
};
